import AbstractService from './AbstractService';

export class ShopService extends AbstractService {
  private async fetchShopSettings(): Promise<Record<string, any>> {
    const response = await this.get<Record<string, any>>(this.endpoint('shopSettings'));
    const data = (response as any)?.data ?? response;

    if ((data as any)?.error) {
      throw new Error((data as any).error?.message || 'Failed to fetch shop settings');
    }

    return data;
  }

  private async fetchShopAddresses(): Promise<Record<string, any>> {
    const response = await this.get<Record<string, any>>(this.endpoint('shopAddresses'));
    const data = (response as any)?.data ?? response;

    if ((data as any)?.error) {
      throw new Error((data as any).error?.message || 'Failed to fetch shop addresses');
    }

    // console.warn('Fetched shop addresses:', data); // Debug log to inspect address data structure

    return data;
  }

  async getShopSettings(): Promise<Record<string, any>> {
    return this.fetchShopSettings();
  }

  async getSetting(key: string): Promise<Record<string, any>> {
    return this.get<Record<string, any>>(this.endpoint('settingsByKey', { key }));
  }

  async getShopInfo(params?: Record<string, any>): Promise<Record<string, any>> {
    try {
      const [settings, addresses] = await Promise.all([this.fetchShopSettings(), this.fetchShopAddresses()]);

      const shopInfo = {
        ...settings,
        addresses,
      };

      // console.warn('Combined shop info:', shopInfo); // Debug log to inspect combined shop info structure

      return shopInfo;
    } catch (error) {
      this.logger.error({ msg: 'Error fetching remote shop info', error });
      return {}; // Return empty object on error to allow app to continue functioning
    }
  }
}

export const shopService = new ShopService();

export default ShopService;
